module.exports = __webpack_public_path__ + "static/media/google-play-badge-nl.d02d24a5.svg";